module.exports = __webpack_public_path__ + "static/media/Зацепин Д. (КФА).7e30a2dd.pdf";